import { motion } from 'framer-motion';
import { PageTransition, FadeIn } from '../components/PageTransition';
import { BackButton } from '../components/BackButton';

const WhyPage = () => {
  return (
    <PageTransition className="min-h-screen bg-[#F8F6F2] flex items-center justify-center py-24 px-6">
      <div className="grain-overlay" />
      <BackButton to="/navigation" label="Back" />

      <div className="max-w-2xl mx-auto text-center">
        <FadeIn delay={0.2}>
          <h2 className="text-xs uppercase tracking-[0.3em] text-[#1A1A1A]/60 mb-6">
            Purpose
          </h2>
          <h1 className="text-4xl md:text-5xl font-light tracking-tight text-[#1A1A1A] mb-16">
            Why
          </h1>
        </FadeIn>

        <FadeIn delay={0.4}>
          <div className="mb-12 text-left">
            <h3 className="text-sm uppercase tracking-[0.15em] font-semibold text-[#1A1A1A] mb-4">
              Importance of Training
            </h3>
            <p className="text-base font-light leading-relaxed text-[#1A1A1A]/80">
              Training ensures consistency, clarity, and confidence in daily store operations. 
              It builds the foundation for exceptional customer experiences and brand representation.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.5}>
          <div className="mb-12 text-left">
            <h3 className="text-sm uppercase tracking-[0.15em] font-semibold text-[#1A1A1A] mb-4">
              Customer Service Training Importance
            </h3>
            <p className="text-base font-light leading-relaxed text-[#1A1A1A]/80">
              Encourages better customer engagement, trust, and stronger brand experience. 
              Every interaction is an opportunity to reinforce The Bear House values.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.6}>
          <div className="border-t border-[rgba(26,26,26,0.1)] pt-8">
            <div className="grid grid-cols-3 gap-6 text-center">
              <div>
                <h4 className="text-2xl font-light text-[#D32F2F] mb-1">100%</h4>
                <p className="text-xs uppercase tracking-wide text-[#1A1A1A]/60">Consistency</p>
              </div>
              <div>
                <h4 className="text-2xl font-light text-[#D32F2F] mb-1">100%</h4>
                <p className="text-xs uppercase tracking-wide text-[#1A1A1A]/60">Clarity</p>
              </div>
              <div>
                <h4 className="text-2xl font-light text-[#D32F2F] mb-1">100%</h4>
                <p className="text-xs uppercase tracking-wide text-[#1A1A1A]/60">Confidence</p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </PageTransition>
  );
};

export default WhyPage;
